import {defineCustomElement} from 'extensions/ui-utils';
import {html, LitElement} from 'lit';
import {classMap} from 'lit/directives/class-map.js';
import stylesheet from './x-message.scss?as=stylesheet';

export class Message extends LitElement {
	static get styles () {
		return [stylesheet];
	}

	static get properties () {
		return {
			type: {
				reflect: true,
				type: String
			}
		};
	}

	constructor () {
		super();

		/**
		 * @type {'info'|'error'|'warning'|'success'}
		 */
		this.type = '';
	}

	render () {
		const classes = {
			'x-messages': true,
			[`x-messages--${this.type}`]: true
		};

		return html`
			<div class="${classMap(classes)}">
				<slot></slot>
			</div>
		`;
	}
};

defineCustomElement('x-message', Message);
